import { ConfigProvider, type ThemeConfig } from "antd";
import clsx from "clsx";
import { memo, type ReactNode } from "react";
import "./TableLayout.scss";

export type TableLayoutProps = {
  filter?: ReactNode;
  table: ReactNode;
  footer?: ReactNode;
  className?: string;
};

const tableLayoutControlTheme: ThemeConfig = {
  components: {
    Select: {
      activeBorderColor: "#a1a9b1",
      hoverBorderColor: "#a1a9b1",
      activeOutlineColor: "transparent",
    },
  },
};

export const TableLayout = memo(
  ({ filter, table, footer, className }: TableLayoutProps) => {
    return (
      <div className={clsx("tableLayout", className)}>
        <ConfigProvider theme={tableLayoutControlTheme}>
          <div className="tableLayoutCard">
            {filter ? <div className="tableLayoutHeader">{filter}</div> : null}

            <div className="tableLayoutBody">
              <div className="tableLayoutResponsive">{table}</div>
            </div>

            {footer ? <div className="tableLayoutFooter">{footer}</div> : null}
          </div>
        </ConfigProvider>
      </div>
    );
  },
);
TableLayout.displayName = "TableLayout";
